module.exports = __webpack_public_path__ + "img/unimed-coracao.d1e0160a.svg";